export default class {
  constructor(delay) {
    this.delay = delay;
    this.acquired = false;
  }

  async run(fn) {
    if (this.acquired) {
      const interval = setInterval(() => {
        if (!this.acquired) {
          clearInterval(interval);
          fn();
        }
      }, this.delay);
    } else {
      this.acquired = true;
      await fn();
      this.acquired = false;
    }
  }
}
